

const StoresView = () => {
  return (
    <></>
  )
}

export default StoresView;
